var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "visibility"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1131_3245",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.333374,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1131_3245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "visibility_2",
    d: "M8.33537 10.5C9.12292 10.5 9.7917 10.2243 10.3417 9.67299C10.8917 9.12166 11.1667 8.45221 11.1667 7.66466C11.1667 6.8771 10.891 6.20832 10.3397 5.65832C9.78837 5.10833 9.11892 4.83333 8.33137 4.83333C7.54381 4.83333 6.87503 5.10899 6.32503 5.66033C5.77503 6.21166 5.50003 6.8811 5.50003 7.66866C5.50003 8.45621 5.7757 9.12499 6.32703 9.67499C6.87837 10.225 7.54781 10.5 8.33537 10.5ZM8.33337 9.26666C7.88892 9.26666 7.51114 9.1111 7.20003 8.79999C6.88892 8.48888 6.73337 8.1111 6.73337 7.66666C6.73337 7.22221 6.88892 6.84444 7.20003 6.53333C7.51114 6.22221 7.88892 6.06666 8.33337 6.06666C8.77781 6.06666 9.15559 6.22221 9.4667 6.53333C9.77781 6.84444 9.93337 7.22221 9.93337 7.66666C9.93337 8.1111 9.77781 8.48888 9.4667 8.79999C9.15559 9.1111 8.77781 9.26666 8.33337 9.26666ZM8.33337 13.05C6.62225 13.05 5.07781 12.55 3.70003 11.55C2.32225 10.55 1.29448 9.25555 0.616699 7.66666C1.29448 6.07777 2.32225 4.78332 3.70003 3.78333C5.07781 2.78333 6.62225 2.28333 8.33337 2.28333C10.0445 2.28333 11.5889 2.78333 12.9667 3.78333C14.3445 4.78332 15.3723 6.07777 16.05 7.66666C15.3723 9.25555 14.3445 10.55 12.9667 11.55C11.5889 12.55 10.0445 13.05 8.33337 13.05ZM8.33203 11.6667C9.67037 11.6667 10.8996 11.3028 12.0199 10.575C13.14 9.84721 13.9945 8.87777 14.5834 7.66666C13.9945 6.45555 13.1404 5.4861 12.0212 4.75833C10.9019 4.03055 9.67303 3.66666 8.3347 3.66666C6.99637 3.66666 5.76709 4.03055 4.64687 4.75833C3.52675 5.4861 2.6667 6.45555 2.0667 7.66666C2.6667 8.87777 3.52631 9.84721 4.64553 10.575C5.76487 11.3028 6.9937 11.6667 8.33203 11.6667Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.b0013ac8adaef268c2ae264f67a16c24.svg";
export { ForwardRef as ReactComponent };